export default __webpack_public_path__ + "static/media/jalepeno.a49882be.svg";